'use client';

import React from 'react';
import type { CreateFlow } from '@/utils/analytics-events';
import { FORMAT_COPY } from '@/lib/create-flow/format-copy';

const FOCUS_RING =
  'focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-[3px] focus-visible:outline-marigold-deep';

/** Rendered above the preview step; a paragraph, not a heading (the step keeps its own h2). */
export function FormatPreviewHeading({ format, onSwitch }: { format: CreateFlow; onSwitch?: () => void }) {
  const copy = FORMAT_COPY[format];
  return (
    <div className="mb-3">
      <p className="text-lg text-gray-900">
        Your <strong className="uppercase tracking-wide text-purple-700">{copy.word}</strong> preview
      </p>
      <p className="text-sm text-gray-600">
        {copy.previewSubline} {copy.previewSwitch}
        {onSwitch && (
          <>
            {' '}
            <button
              type="button"
              onClick={onSwitch}
              aria-label={`Switch to a ${FORMAT_COPY[format === 'comic' ? 'picture-book' : 'comic'].noun.toLowerCase()}`}
              className={`min-h-11 font-semibold text-purple-700 underline underline-offset-4 ${FOCUS_RING}`}
            >
              Switch
            </button>
          </>
        )}
      </p>
    </div>
  );
}
